// frontend/src/homepage/adHeroHold.js
//
// The React half of the ad-hero hold. public/index.html adds AD_HERO_HOLD_CLASS
// to <html> before first paint on "/" for a visit from the "buy leads" ad, and
// homepage.css keeps the hero's copy column invisible while it is set, so the
// prerendered DEFAULT words are never painted before the ad words replace
// them. pages/Homepage.js calls releaseAdHeroHold() once the hero renders its
// FINAL variant - the ad copy, or the default for anyone the ad copy is not
// for - so the default hero can never be left hidden. The head script's 3s
// timer is the failsafe for a React that never gets that far.

/** Kept literally in sync with public/index.html and homepage.css (test-pinned). */
export const AD_HERO_HOLD_CLASS = "lf-ad-hero-hold";

/** Reveal the hero copy. Idempotent, and never throws. */
export function releaseAdHeroHold() {
  try {
    if (typeof document === "undefined" || !document.documentElement) return;
    document.documentElement.classList.remove(AD_HERO_HOLD_CLASS);
  } catch (e) {
    /* nothing to reveal */
  }
}
